import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";

// Components
import GeneralLoader from "../../../GeneralLoader";
import ErrorWrap from "../../../utils/error-success/ErrorWrap";
import Button from "../../../utils/Button";
import GeneratePasswordConfirmationDialog from "../../../utils/dialogs/GeneratePasswordConfirmationDialog";

// State
import {
	generateReviewerPassword,
	passwordGenerateClearStatus
} from "../../../../store/actions/reviewers";

// This will style each option to be their own color
const colorInputStyles = {
	padding: '1em',
	background: '#bdbdbd',
	width: 'fit-content'
}

class AccountStatusFieldset extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showDialog: false
		};

		this.dataProps = ["account_accepted", "status", "color"];
		this.miscProps = [
			"errors",
			"profileStatusesError",
			"profileStatusesLoading",
			"profileStatuses",
			"passwordGenerateLoading",
			"userTypesError",
			"userTypesLoading",
			"userTypes",
			"inProcess"
		];
	}

	shouldComponentUpdate(nextProps, nextState) {
		// Check the component state to see if it's changed
		if (nextState !== this.state) return true;

		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop];
		});
		const miscPropResults = this.miscProps.some(prop => {
			return this.props[prop] !== nextProps[prop];
		});

		// If any local props changed, we will rerender
		return dataPropResults || miscPropResults;
	}

	generatePassword = () => {
		this.props.generateReviewerPassword(this.props.data.id, this.props.admin.token);
	};

	render() {
		const {
			data,
			errors,
			profileStatuses,
			profileStatusesError,
			profileStatusesLoading,
			userTypes,
			userTypesError,
			userTypesLoading,
			inProcess
		} = this.props;

		return (
			<div className="fieldset">
				<div className="title-label">Account Status</div>
				{/* <div style={{marginBottom: '0.75em'}}>Note: Setting the status to "Trainee" or "Reviewer" will automically generate a password if one wasn't already generated previously and this will also send and email with the login information to the reviewer.</div> */}
				<div className="fieldset-indent">

					{/* Checkboxes to select color status */}
					{inProcess ? <React.Fragment></React.Fragment> :
						<div className="form-field checkbox pb1">
							<label className="pb1">Color Status</label>

							{!!errors.color && <ErrorWrap animate={1}>{errors.color}</ErrorWrap>}
							<div className="floated-field-container" style={colorInputStyles}>
								<div
									title="Great reviewer. Team lead."
									className={`custom-label checkbox-label${
										inProcess ? " disabled-label" : ""
									}`}
								>
									<input
										type="radio"
										id="color_green"
										value="1"
										disabled={inProcess}
										checked={parseInt(data.color) === 1}
										onChange={e => this.props.handleRadioClick(e, "color")}
									/>
									<label htmlFor="color_green" style={{color: 'green'}}>Green</label>
								</div>
								<div
									title="Good reviewer. Need a leader support."
									className={`custom-label checkbox-label${
										inProcess ? " disabled-label" : ""
									}`}
								>
									<input
										type="radio"
										id="color_yellow"
										value="2"
										disabled={inProcess}
										checked={parseInt(data.color) === 2}
										onChange={e => this.props.handleRadioClick(e, "color")}
									/>
									<label htmlFor="color_yellow" style={{color: 'yellow'}}>Yellow</label>
								</div>
								<div
									title="Need to follow up and specific training."
									className={`custom-label checkbox-label${
										inProcess ? " disabled-label" : ""
									}`}
								>
									<input
										type="radio"
										id="color_orange"
										value="3"
										disabled={inProcess}
										checked={parseInt(data.color) === 3}
										onChange={e => this.props.handleRadioClick(e, "color")}
									/>
									<label htmlFor="color_orange" style={{color: '#c47f00'}}>Orange</label>
								</div>
								<div
									title="New reviewer - Evaluation pending."
									className={`custom-label checkbox-label${
										inProcess ? " disabled-label" : ""
									}`}
								>
									<input
										type="radio"
										id="color_white"
										value="4"
										disabled={inProcess}
										checked={parseInt(data.color) === 4}
										onChange={e => this.props.handleRadioClick(e, "color")}
									/>
									<label htmlFor="color_white" style={{color: 'white'}}>White</label>
								</div>
								<div
									title="Need to have obligatory training or be removed."
									className={`custom-label checkbox-label${
										inProcess ? " disabled-label" : ""
									}`}
								>
									<input
										type="radio"
										id="color_red"
										value="5"
										disabled={inProcess}
										checked={parseInt(data.color) === 5}
										onChange={e => this.props.handleRadioClick(e, "color")}
									/>
									<label htmlFor="color_red" style={{color: 'red'}}>Red</label>
								</div>
							</div>
						</div>
					}

					{userTypesError ? (
						<ErrorWrap>{userTypesError}</ErrorWrap>
					) : userTypesLoading ? (
						<GeneralLoader />
					) : (
						<div className="floated-field-container">
							<div className="form-field half-field">
								{!!errors.user_type && (
									<ErrorWrap animate={1}>{errors.user_type}</ErrorWrap>
								)}

								<Select
									classNamePrefix="react-select"
									placeholder={"Select user type"}
									isClearable={false}
									isDisabled={inProcess}
									name={`account_accepted`}
									value={userTypes.filter(({ id }) => id === data.account_accepted)}
									onChange={({ id }) => {
										this.props.updateSelectedValue(id, "account_accepted");
									}}
									options={userTypes}
									getOptionLabel={({ title }) => title}
									getOptionValue={({ id }) => id}
								/>
							</div>
						</div>
					)}

					{profileStatusesError ? (
						<ErrorWrap>{profileStatusesError}</ErrorWrap>
					) : profileStatusesLoading ? (
						<GeneralLoader />
					) : (
						<div className="floated-field-container">
							<div className="form-field half-field">
								{!!errors.status && <ErrorWrap animate={1}>{errors.status}</ErrorWrap>}

								<Select
									classNamePrefix="react-select"
									placeholder={"Select status"}
									isClearable={false}
									isDisabled={inProcess}
									name={`status`}
									value={profileStatuses.filter(({ id }) => id === data.status)}
									onChange={({ id }) => {
										this.props.updateSelectedValue(id, "status");
									}}
									options={profileStatuses}
									getOptionLabel={({ title }) => title}
									getOptionValue={({ id }) => id}
								/>
							</div>
						</div>
					)}

					{data.id && this.props.role === 'admin' && (
						<div className="btn_container pt1">
							<Button
								text={"Generate password"}
								clickHandler={() => {
									this.props.passwordGenerateClearStatus();
									this.setState({ showDialog: true });
								}}
								isDisabled={inProcess}
							/>
							<GeneratePasswordConfirmationDialog
								show={this.state.showDialog}
								generateInProgress={this.props.passwordGenerateLoading}
								id={data.id}
								itemTitle={`${data.fname} ${data.lname}`}
								handleGenerate={this.generatePassword.bind(this)}
								handleClose={() => this.setState({ showDialog: false })}
								generateErrors={this.props.passwordGenerateErrors}
								generateSuccess={this.props.passwordGenerateSuccess}
							/>
						</div>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		admin: state.user.admin,
		role: state.user.admin.user.role,
		passwordGenerateLoading: state.reviewers.passwordGenerateLoading,
		passwordGenerateErrors: state.reviewers.passwordGenerateErrors,
		passwordGenerateSuccess: state.reviewers.passwordGenerateSuccess
	};
};

export default connect(
	mapStateToProps,
	{ generateReviewerPassword, passwordGenerateClearStatus }
)(AccountStatusFieldset);



// WEBPACK FOOTER //
// ./src/components/admin/reviewers/form-components/AccountStatusFieldset.js